import styled from 'styled-components'
import theme from 'styled-theming'

import { COLORS, THEME, typeScale, THEMES } from '../../styles'

const VARIANTS = {
  name: {
    color: theme('variant', {
      main: THEME.COLORS.foreground.primary,
      white: COLORS.white,
      print: THEMES.light.foreground.primary,
    }),
  },
  image: {
    borderColor: theme('variant', {
      main: THEME.COLORS.foreground.tertiary,
      white: COLORS.white,
      print: THEMES.light.foreground.tertiary,
    }),
  },
  optional: {
    color: theme('variant', {
      main: COLORS.white,
      white: COLORS.white,
      print: COLORS.white,
    }),
    backgroundColor: theme('variant', {
      main: COLORS.cobalt,
      white: COLORS.cobalt,
      print: COLORS.cobalt,
    }),
  },
}

const SIZES = {
  container: {
    width: theme('size', {
      normal: '8rem',
      small: '8rem',
      xSmall: '4rem',
    }),
  },
  image: {
    width: theme('size', {
      normal: '8rem',
      small: '6.4rem',
      xSmall: '4rem',
    }),
    height: theme('size', {
      normal: '8rem',
      small: '6.4rem',
      xSmall: '4rem',
    }),
  },
  optional: {
    fontSize: theme('size', {
      normal: '1.2rem',
      small: '1rem',
      xSmall: '1rem',
    }),
    padding: theme('size', {
      normal: '0.4rem 0.8rem',
      small: '0.2rem 0.4rem',
      xSmall: '0.2rem 0.4rem',
    }),
  },
}

const Styled = styled.div`
  width: ${SIZES.container.width};
  text-align: center;
  position: relative;
  cursor: ${({ onClick }) => (onClick ? 'pointer' : 'default')};
`
Styled.imageContainer = styled.div`
  background: none;
  display: block;
  height: auto;
  width: 100%;
  margin-bottom: ${({ standaloneImage }) => (standaloneImage ? 0 : '0.8rem')};
  position: relative;
`
Styled.image = styled.div`
  border-radius: 9999px;
  overflow: hidden;
  position: relative;
  background: ${COLORS.white};
  width: ${SIZES.image.width};
  height: ${SIZES.image.height};
  box-sizing: border-box;
  border: solid 0.1rem ${VARIANTS.image.borderColor};
  margin: 0 auto;
`
Styled.missingImage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`
Styled.children = styled.div`
  background: none;
  border-radius: 4rem;
  display: block;
  height: 8rem;
  width: 8rem;
  margin-bottom: 0.8rem;
`
Styled.quantity = styled.p`
  width: 100%;
  ${typeScale('caption')};
  text-align: center;
  display: block;
  white-space: nowrap;
  text-transform: lowercase;
  text-overflow: ellipsis;
  color: ${VARIANTS.name.color};
`
Styled.name = styled.p`
  ${typeScale('caption')};
  hyphens: auto;
  color: ${VARIANTS.name.color};

  &:first-letter {
    text-transform: uppercase;
  }
`
Styled.optional = styled.p`
  ${typeScale('caption', {
    textTransform: 'capitalize',
  })};
  font-size: ${SIZES.optional.fontSize};
  display: inline-block;
  background: ${VARIANTS.optional.backgroundColor};
  color: ${VARIANTS.optional.color};
  border: 0;
  border-radius: 9999px;
  padding: ${SIZES.optional.padding};
  position: absolute;
  bottom: -0.4rem;
  left: 50%;
  transform: translateX(-50%);
`

export default Styled
